
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/sub/domenai",
      function () {
        return require("private-next-pages/lt/sub/domenai.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/sub/domenai"])
      });
    }
  